<template>
  <a-card :bordered="false">
    <a-button class="m-b-20" type="primary" v-has:precisionSmsAdd="()=>{$router.push('/messageCenter/precision/smsCreate?type=add')}">
      <PlusOutlined />
      新建短信群发
    </a-button>
    <!-- 时间 -->
    <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" layout='inline'
      :onFinish='pageSearchChange'>
      <a-form-item label="短信内容" name='content'>
        <a-input v-model:value="search.content" placeholder="请输入短信内容进行搜索" :style="{'width':'264px'}" />
      </a-form-item>
      <a-form-item label="发送时间" name=''>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" ghost v-has:precisionSmsLog='()=>{showFail=true}'>失败重发记录</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' class="tableFixBox" :scroll="{ x: 'max-content'}">
      <template v-slot:send_time="{ record }">
        <p v-if='!record.send_time'>{{record.create_time}}</p>
        <p v-else>{{momentTime(record.send_time*1000).format('YYYY-MM-DD HH:mm:ss')}}</p>
      </template>
      <template v-slot:action="{ record }">
        <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item v-if='record.send_time&&record.status==0'>
                <a href="javascript:;"  v-has:precisionSmsEdit="()=>{$router.push('/messageCenter/precision/smsEdit?type=edit&id='+record.id)}">编辑</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;"  v-has:precisionSmsDetail="()=>{showMore=true;itemId=record.id}">发送详情</a>
              </a-menu-item>
              <a-menu-item v-if='record.status!=0'>
                <a href="javascript:;"  v-has:precisionSmsSendAgain="()=>sendAgain(record)" >失败重发</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
  </a-card>
  <a-modal :keyboard="false" title="发送详情" centered v-model:visible="showMore" :width="1000" :footer="null" destroyOnClose>
    <sendOutLog :id='itemId'></sendOutLog>
  </a-modal>
  <a-modal :keyboard="false" title="失败重发记录" centered v-model:visible="showFail" :width="1200" :footer="null" destroyOnClose>
    <failLog></failLog>
  </a-modal>
</template>
<script>
  import { DownOutlined,PlusOutlined } from "@ant-design/icons-vue";
  import { inject, reactive, ref, toRefs } from "vue";
  import { getSmsGroupList,smsSendAgain } from "@/api/message.js";
  import { iscode } from "@/utils/app";
  import { message } from 'ant-design-vue';
  import sendOutLog from './sendOutLog.vue';
  import failLog from './failLog.vue'
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
    start_time: '',
    end_time: '',
    content: ''
  };
  export default {
    components: {
      DownOutlined,PlusOutlined,sendOutLog,failLog
    },
    setup() {
      const state = reactive({
        time: [],
        listLoading: false,
        showMore:false,
        showFail:false,
        itemId:'',
        total:0
      })
      let columns = [
        {
          title: "群发对象",
          dataIndex: "send_type_text",
          key: "send_type_text",
        },
        {
          title: "短信内容",
          dataIndex: "content",
          key: "content",
        },
        {
          title: "发送状态",
          dataIndex: "status_text",
        },
        {
          title: "发送数",
          dataIndex: "send_numbers",
          key: "send_numbers",
        },
        {
          title: "成功数",
          dataIndex: "success_numbers",
          key: "success_numbers",
        },
        {
          title: "失败数",
          dataIndex: "fail_numbers",
          key: "fail_numbers",
        },
        {
          title: "发送时间",
          dataIndex: "send_time",
          key: "send_time",
          slots: { customRender: "send_time" },
        },
        {
          title: "操作",
          key: "action",
          width: 120,
          fixed: 'right',
          slots: { customRender: "action" }
        },
      ];

      const router = inject('$router')
      const $Modal = inject("$Modal");
      const momentTime = inject('momentTime')
      //初始化 分页信息和筛选项信息
      const search = ref({ ...defSearch });
      const data = ref([]);
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //失败重发
      const sendAgain = (e) => {
        $Modal.confirm({
          centered: true,
          title: '提示',
          content: '确定执行失败重发操作吗？', onOk: async () => {
            let res = await smsSendAgain(e.id).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      //获取列表
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getSmsGroupList(values).then((res) => res.data);
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      // 时间筛选
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
        initData(search.value)
      }
      initData(search.value)
      return {
        columns,
        data,
        ...toRefs(state),
        search,
        onChange,
        momentTime,
        sendAgain,
        pageCurrentChange,
        pageSizeChange,
        pageSearchChange
      };
    },
  };
</script>